import { useLocation } from 'react-router-dom';
import {
  HistoryListSkeleton,
  SessionDetailSkeleton,
  SessionOverviewSkeleton,
} from '@/components/ui/skeleton';

function ShimmerBlock({ className }: { className: string }) {
  return <div className={`oche-shimmer rounded-md bg-[var(--color-line)] ${className}`} aria-hidden />;
}

/** Route-aware Suspense fallback - skeleton matches destination layout. */
export function RouteSkeleton() {
  const { pathname } = useLocation();

  if (pathname.startsWith('/history/') && pathname.length > '/history/'.length) {
    return (
      <div className="oche-enter-fade">
        <SessionDetailSkeleton />
      </div>
    );
  }

  if (pathname.startsWith('/history')) {
    return (
      <div className="oche-enter-fade">
        <HistoryListSkeleton />
      </div>
    );
  }

  if (pathname.startsWith('/sessions/new')) {
    return (
      <div className="oche-enter-fade oche-enter-up mx-auto max-w-lg grid gap-4 py-2">
        <ShimmerBlock className="h-8 w-48" />
        <ShimmerBlock className="h-4 w-full max-w-sm" />
        <ShimmerBlock className="h-10" />
        <div className="grid gap-2">
          <ShimmerBlock className="h-24" />
          <ShimmerBlock className="h-24" />
        </div>
      </div>
    );
  }

  return (
    <div className="oche-enter-fade">
      <SessionOverviewSkeleton />
    </div>
  );
}
